import { FallbackProps } from 'react-error-boundary';
import { Button } from 'components/buttons';

export function TruthTableErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  console.error('TruthTable crashed:', error);

  return (
    <section className="dp-truthtable-error-fallback">
      <p className="dp-truthtable-error-fallback__message">
        An unexpected condition occurred, please try to reload or contact your system administrator for more help.
      </p>
      <Button variant="primary" onClick={resetErrorBoundary}>
        Reload
      </Button>
    </section>
  );
}
